module.exports = __webpack_public_path__ + "img/heart_structureFunction_summary.981333bc.png";